import { createSlice } from "@reduxjs/toolkit";
import { getChatBotThunk, getChatBotClickHistoryThunk, createChatBotThunk, editChatBotThunk, deleteChatBotThunk } from "./chatBotThunk";

const initialState = {
    status: "idle",
    status1: "idle",
    error: null,
    success: "",
    getChatBotDetails: [],
    getBotClickHistory: [],
    chatBotCreationDetails: []
};

const chatBotsSlice = createSlice({
    name: "chatBot",
    initialState,
    reducers: {
        resetBotState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
        },
        setChatBotDetails: (state, action) => {
            state.chatBotCreationDetails = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChatBotThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getChatBotThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                 state.success = action.payload?.success ?? false;
                state.error = null;
                state.getChatBotDetails = action.payload;
            })
            .addCase(getChatBotThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })

            // Click History
            .addCase(getChatBotClickHistoryThunk.pending, (state) => {
                state.status1 = "loading";
                state.error = null;
            })
            .addCase(getChatBotClickHistoryThunk.fulfilled, (state, action) => {
                state.status1 = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.getBotClickHistory = action.payload;
            })
            .addCase(getChatBotClickHistoryThunk.rejected, (state, action) => {
                state.status1 = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            .addCase(createChatBotThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(createChatBotThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(createChatBotThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            .addCase(editChatBotThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(editChatBotThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(editChatBotThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })


            .addCase(deleteChatBotThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(deleteChatBotThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(deleteChatBotThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "Login failed";
                state.success = "";
            })
    },
});

export const { resetBotState, setChatBotDetails } = chatBotsSlice.actions;
export default chatBotsSlice.reducer;